// extracted by mini-css-extract-plugin
module.exports = {"marketplaceMenuSA":"_35qws","marketplaceMenuSa":"_35qws","marketplaceMenu":"_3IDur","search-menu":"_2fxJv","searchMenu":"_2fxJv"};